module.exports = __webpack_public_path__ + "assets/icon-conductor-aluminiumWire.31909313.svg";